// extracted by mini-css-extract-plugin
export default {"svg":"LogoutButton_svg__RZl6-","div":"LogoutButton_div__zkFs0"};